<template>
  <div>
    <router-view></router-view>
    <PageHeaderLayout>
      <div class="main-page-content">
        <div class="header">
          <div class="left_box">
            <!-- <span class="info">公司名称：</span>
            <el-input
              class="company_input"
              placeholder="请输入公司名称"
              v-model="searchCompanyName"
              clearable
            >
            </el-input>
            <el-button type="primary" @click="search">查询</el-button> -->
          </div>
          <el-button type="primary" class="add_btn" @click="handleAdd"
            >新增</el-button
          >
        </div>

        <el-tabs v-model="tab_active" type="card" @tab-click="handleClick">
          <el-tab-pane
            v-for="(item, index) in this.tabsList"
            :label="item.label"
            :key="index"
            :name="item.name"
            class="tab-item"
          >
          </el-tab-pane>
          <ApeTable
            ref="apeTable"
            :data="dataList"
            :columns="columns"
            :loading="loadingStaus"
            :pagingData="pagingData"
            :current_Page="currentPage"
            @switchPaging="switchPaging"
            highlight-current-row
          >
            <el-table-column width="200" align="center" label="操作">
              <template slot-scope="scope">
                <div>
                  <el-button
                    size="mini"
                    class="edit_btn"
                    @click="handleEdit(scope.row)"
                    type="primary"
                    >查看</el-button
                  >
                  <el-button
                    size="mini"
                    @click="handleDelete(scope.row)"
                    type="danger"
                    >删除</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </ApeTable>
        </el-tabs>
        <el-dialog
          :title="showDetail?'查看':'添加'"
          v-if="dialogVisible"
          :visible.sync="dialogVisible"
          width="40%"
          center
          :before-close="handleClose"
        >
          <el-form
            :disabled="showDetail"
            :model="form"
            :rules="rules"
            ref="ruleForm"
            label-width="120px"
          >
            <el-form-item label="类型" prop="operate_type">
              <el-radio-group disabled v-model="form.operate_type">
                <el-radio label="2">子账号白名单</el-radio>
                <el-radio label="1">主账号白名单</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="公司名称" prop="company_id">
              <el-select
                @change="selectCompany"
                v-model="form.company_id"
                filterable
                placeholder="请选择公司"
              >
                <el-option
                  v-for="item in companyList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="服务公司" prop="channel_account">
              <el-select
                @change="selectChannelAccount"
                v-model="form.channel_account"
                filterable
                placeholder="请选择服务公司"
              >
                <el-option
                  v-for="item in allTaxSource"
                  :key="item.channel_account"
                  :label="item.channel_name"
                  :value="item.channel_account"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="检查类型" prop="check_type">
              <el-radio-group v-model="form.check_type">
                <el-radio label="1">按银行账号</el-radio>
                <el-radio label="2">按银行户名</el-radio>
                <el-radio label="3">按银行账号加户名</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              v-if="form.check_type != 1"
              label="银行户名"
              prop="bank_name"
            >
              <el-input type="text" v-model="form.bank_name"></el-input>
            </el-form-item>
            <el-form-item
              v-if="form.check_type != 2"
              label="银行账号"
              prop="bank_no"
            >
              <el-input type="number" v-model="form.bank_no"></el-input>
            </el-form-item>
            <!-- <el-form-item label="白名单类型" prop="whitelist_type">
              <el-select
                disabled
                v-model="form.whitelist_type"
                filterable
                placeholder="请选择白名单类型"
                clearable
              >
                <el-option
                  v-for="item in whitelistTypeList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="借贷标识" prop="flag">
              <el-select
                disabled
                v-model="form.flag"
                filterable
                placeholder="请选择借贷标识"
                clearable
              >
                <el-option
                  v-for="item in flagList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item> -->
          </el-form>

          <span slot="footer" class="dialog-footer">
            <el-button class="left_btn" @click="cancel">取 消</el-button>
            <el-button v-if="!showDetail" type="primary" @click="handleSure">确 定</el-button>
          </span>
        </el-dialog>
      </div>
    </PageHeaderLayout>
  </div>
</template>

<script>
import ApeTable from "@/components/ApeTable";
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import { Message } from "element-ui";
export default {
  components: {
    ApeTable,
    PageHeaderLayout,
  },
  data() {
    return {
      showDetail:false,
      searchCompanyName: "",
      tab_active: "2",
      tabsList: [
        {
          label: "子账号白名单",
          name: "2",
        },
        {
          label: "主账号白名单",
          name: "1",
        },
      ],
      form: {
        company_id: "",
        channel_account: "",
        uid: "",
        check_type: "1",
        bank_no: "",
        bank_name: "",
        whitelist_type: 3,
        flag: "C",
        operate_type: "2",
      },
      rules: {
        company_id: [
          { required: true, message: "请选择公司", trigger: "change" },
        ],
        channel_account: [
          { required: true, message: "请选择税源地", trigger: "change" },
        ],
        check_type: [
          { required: true, message: "请选择检查类型", trigger: "change" },
        ],
        bank_no: [
          { required: true, message: "请输入银行账号", trigger: "change" },
        ],
        bank_name: [
          { required: true, message: "请输入银行名称", trigger: "change" },
        ],
      },
      companyList: [],
      allTaxSource: [],
      flagList: [
        { id: "C", label: "贷（收款）" },
        { id: "D", label: "借（付款）" },
      ],
      whitelistTypeList: [
        { id: 1, label: "智能账号收款白名单" },
        { id: 2, label: "智能账号付款白名单" },
        { id: 3, label: "清分台账编码收款白名单" },
        { id: 4, label: "清分台账编码付款白名单" },
      ],
      dialogVisible: false,
      dataList: [],
      columns: [
        {
          title: "公司id",
          value: "company_id",
          header_align: "center",
          align: "center",
        },
        {
          title: "公司名称",
          value: "companyName",
          header_align: "center",
          align: "center",
        },
        {
          title: "服务名称",
          value: "channelName",
          header_align: "center",
          align: "center",
        },
        {
          title: '账号信息',
          width: 300,
          header_align: 'center',
          value: [
            {label:'银行户名：',value:'bank_name'},
            {label:'银行账号：',value:'bank_no'},
          ],
        },
        {
          title: "创建时间",
          value: "created_at",
          header_align: "center",
          align: "center",
        },
      ],
      loadingStaus: false,
      // 分页信息
      pagingData: {
        is_show: true,
        layout: "total, sizes, prev, pager, next, jumper",
        total: 0,
      },
      offset: 0,
      currentPage: 1,
    };
  },
  mounted() {
    this.init();
    this.getCompanyList();
  },
  methods: {
    //切换tab
    async handleClick() {
      this.init();
    },
    selectCompany() {
      this.allTaxSourceList();
    },
    selectChannelAccount() {
      let account_info = this.allTaxSource.filter(
        (item) => item.channel_account === this.form.channel_account
      );
      console.log(account_info);
      this.form.uid = account_info[0].uid;
    },
    async allTaxSourceList() {
      this.allTaxSource = [];
      this.form.channel_account = "";
      this.form.uid = "";
      const result = await this.$api.subAccount(this.form.company_id);
      this.allTaxSource = result.filter((item) => item.bankPid === "pinganpay");
    },
    async getCompanyList() {
      const res = await this.$api.getUserCompanyList();
      this.companyList = res;
    },
    switchPaging(e) {
      this.currentPage = e;
      this.init();
    },
    search() {
      this.init();
    },
    // 初始化公司列表
    async init(type) {
      this.loadingStaus = true;
      let pagingInfo = this.$refs["apeTable"].getPagingInfo(type);
      pagingInfo.type = this.tab_active;
      let { data, pages } = await this.$api.getPinganWhiteList(pagingInfo);
      data.map((item) => {
        item.bank_name = item.bank_name || '-';
        item.bank_no = item.bank_no || '-';
        item.companyName = item.company.name;
        item.channelName = item.settlement.channel_name;
      });
      this.$nextTick(() => {
        this.dataList = data;
      });
      this.pagingData.total = pages.total;
      this.offset = pages.offset;
      this.loadingStaus = false;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    cancel() {
      this.dialogVisible = false;
    },
    handleEdit(row){
      this.showDetail = true;
      let {
        company_id,
        channel_account,
        uid,
        check_type,
        bank_no,
        bank_name,
        whitelist_type,
        flag,
      }=row;
      this.form = {
        company_id,
        channel_account,
        uid,
        check_type:check_type+'',
        bank_no,
        bank_name,
        whitelist_type,
        flag,
        operate_type: this.tab_active,
      };
      this.dialogVisible = true
    },
    // 新增
    handleAdd() {
      this.form = {
        company_id: "",
        channel_account: "",
        uid: "",
        check_type: "1",
        bank_no: "",
        bank_name: "",
        whitelist_type: 3,
        flag: "C",
        operate_type: this.tab_active,
      };
      this.showDetail = false;
      this.dialogVisible = true;
    },
    // 删除
    handleDelete(v) {
      this.$confirm("此操作将永久删除该项, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await this.$api.deletePinganWhite({ id: v.id });
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.init();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 提交
    handleSure() {
      this.$refs["ruleForm"].validate(async (valid) => {
        if (valid) {
          if (this.tab_active === "1") {
            // 主账号白名单  白名单类型改为 1
            this.form.whitelist_type = 1;
          }
          await this.$api.createPinganWhite(this.form);
          this.dialogVisible = false;
          Message.success("操作成功");
          this.init();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.main-page-content {
  .header {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    .left_box {
      .info {
        font-size: 14px;
        color: #606266;
      }
      .company_input {
        width: 200px;
        margin-right: 20px;
      }
    }
    .add_btn {
      margin-right: 50px;
    }
  }
  .dialog-footer {
    .left_btn {
      margin-right: 20px;
    }
  }
  .edit_btn {
    margin-right: 2px;
  }
}
</style>
